import { createContext } from 'react';
export interface StreamViewNavigation {
  showInAxonView: (eventId: string) => void;
  showInChatView: (eventId?: string) => void;
}
export const AxonViewContext = createContext<StreamViewNavigation>({
  showInAxonView: () => undefined,
  showInChatView: () => undefined,
});
